export default __webpack_public_path__ + "static/media/InstaIcon.de60d6bd.svg";